module.exports = __webpack_public_path__ + "img/performance-blog - Copy.adc61cc4.png";